<!--
================================================
Composant gérant le formulaire de modification du mot de passe du compte

(/fr/cronocloud-inc/user/settings)
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div>

        <div class="formSection">

            <div class="spacer">

                <div class="contTitle has-text-left">
                    <h3 class=""><font-awesome-icon class="icon" :icon="['fas', 'key']" />{{$t('MotDePasse')}}</h3>
                </div>

                <form action="" v-on:keyup.enter="validateBeforeSubmit">
                    <div class="field">

                            <div class="control">
                                <p class="help has-text-left">{{$t('LeMdpAvecLequelVousVousConnectez')}}
                                    <!--({{$t('VousDevrezVousReconnecterApresModif')}})-->
                                </p> <br>


                                <label class="label has-text-left has-text-grey">{{$t('motDePasseActuel')}}</label>

                                <!--#username4Manager doit être suivi par le champs password !
                                    (https://www.chromium.org/developers/design-documents/create-amazing-password-forms)
                                    (https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofilling-form-controls%3A-the-autocomplete-attribute)
                                -->
                                <input id="username4Manager" type="text" style="display:none" autocomplete="username" v-bind:value="username">
                                <input class="input" v-model="currentPassword"
                                       v-validate="'required|min:6|max:20'"
                                       data-vv-validate-on="change" id="userSetting_currentPassword"
                                       name="userSetting_currentPassword" type="password" v-bind:placeholder="$t('motDePasseActuel')">
                                <p class="help is-danger has-text-left" id="error_userSetting_currentPassword">{{errors.first('userSetting_currentPassword') }}</p>
                                <p v-if="showErrorBadCredentials" class="help is-danger has-text-left" id="errorBadCredentials">{{ $t('leMotDePasseEstIncorrect')}}</p>
                            </div>

                        <br>
                            <div class="control has-icons-left">

                            <label class="label has-text-left has-text-grey">{{$t('nouveauMotDePasse')}}</label>
                            <input class="input" v-model="newPassword"
                                   autocomplete="new-password"
                                   v-validate="'required|min:6|max:20'"
                                   data-vv-validate-on="change" id="userSetting_newPassword"
                                   name="userSetting_newPassword" type="password" v-bind:placeholder="$t('nouveauMotDePasse')">
                            <p class="help is-danger has-text-left" id="error_userSetting_newPassword">{{errors.first('userSetting_newPassword') }}</p>
                        </div>

                    </div>
                </form>

            </div>

            <div class="contFoot">
                <div class="field is-grouped">
                    <p class="control">
                        <a  v-on:click="validateBeforeSubmit" id="PasswordSubmitBtn"
                            class="button is-primary has-text-white btnValider" v-bind:class="{'is-loading':isSubmiting}">
                            <font-awesome-icon :icon="['fas', 'check']" class="icon"/>
                            {{$t('valider')}}
                        </a>
                    </p>
                </div>
            </div>

        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'UserSettingInfosComp',
        mixins: [SentryMixin, GlobalErrorNotification,InterceptorMixin, TrackingMixin],
        // components: {},
        data: function () {
            return {
                isSubmiting: false ,     // indique si le formulaire est en cours de soumission
                currentPassword: null,
                newPassword: null,
                showErrorBadCredentials: false,
            }
        },
        computed: {
            // https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
            // computed props for store :
            ...mapState({
                organizationSlug: state => state.organization.slug,
                userSlug: state => state.user.slug,
                username: state => state.user.email // username du compte pour gestionnaire de password
            }),

        },

        methods: {

            /*
            * Valide le formulaire avant sa soumission
            */
            validateBeforeSubmit() {

                this.showErrorBadCredentials = false;
                this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
                this.isSubmiting = true;

                let self = this
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        self.sendFormQuery();
                    }
                    else { // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                        self.isSubmiting = false;
                    }

                })
            },

            /*
            Envoi la requête pour envoyer le formulaire
            */
            sendFormQuery(){

                let self = this;
                return self.$http
                    .patch(`organizations/${self.organizationSlug}/users/${self.userSlug}`, {
                            currentPassword: self.currentPassword,
                            plainPassword: self.newPassword
                        },
                        {headers: {Authorization: self.$auth.header()}}
                        )
                    .then(function (response) {
                        if(response.status == 200){
                            self.$store.commit('UpdateGlobalNotificationComp', {
                                'isVisible': true,
                                'color': 'is-success',
                                'message': self.$t('VotreMdpAEtéModifié')
                            });

                            self.ga4GlobalEventTrack('Password modified' , {})

                          self.$mixpanel.track("account password modified");

                        }
                    })
                    .catch(function (error) {
                        if (error.response.status === 400 && error.response.data.message === 'bad credentials') {
                            self.showErrorBadCredentials = true;
                        }
                        else {
                            // On catch ici sauf ce qui relève des intercepteurs Axios
                            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                                let errorCode = '0020'
                                self.showGlobalErrorNotif(self,errorCode)
                                self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in password edit query"})
                              self.$gtag.exception({'description': 'error '+errorCode + ' | error in password edit query', 'fatal': false})
                              self.$sentry.captureMessage(`Error ${errorCode} > error in password edit query : ${error}`, 'error')
                            }
                        }

                    }).then(() =>{
                        // toujours exécuté
                        self.isSubmiting = false;
                    })

            },

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)

        created: function () {

        },

        mounted: function () {
        },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
